// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".nav-content{margin-top:10px;font-family:\"F37Ginger\",sans-serif}.nav-content div,.nav-content p{margin:0;color:#fff;font-size:14px;letter-spacing:.88px;line-height:28px}.nav-content#nav-content a{display:inline-block}.fade-enter-active,.fade-leave-active{transition:opacity .2s}.fade-enter,.fade-leave-to{opacity:0}.newsletter-content .column:first-child{padding-right:10px}.newsletter-content .column:nth-child(2){padding-left:10px}", ""]);
// Exports
module.exports = exports;
